export default __webpack_public_path__ + "static/media/metamask.a1273845.png";